import * as React from 'react';
import { SearchBox } from '@elastic/react-search-ui';
import glassIcon from '../../icons/magnifying-glass.svg';
import { Config } from '../../helper';

export default function OpenSearchSearchBox() {
  return (
    <div className='block block--search-box'>
      <div className="search-icon">
        <img src={glassIcon} alt=""/>
      </div>

      <SearchBox
        searchAsYouType={true}
        inputProps={{placeholder: Config.I18n.SearchBox.Placeholder}}/>
    </div>
  )
}
